module.exports = __webpack_public_path__ + "img/acs-login.c9222609.png";